import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { ThemeProvider } from "@/contexts/ThemeContext";
import { ProgrammeProvider } from "@/contexts/ProgrammeContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ThemeProvider>
      <ProgrammeProvider>
        <App />
      </ProgrammeProvider>
    </ThemeProvider>
  </React.StrictMode>,
);
